<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
					<h3>Edit Product <b-breadcrumb :items="breadcrumb"></b-breadcrumb></h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill  @click="showCsvModal()"><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Generate CSV</b-button>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
                    <div class="container-box">
                        
                        <b-tabs content-class="mt-3" small class="mt-3 mx-3">
                            <b-tab title="Product" href="#product" >   
                                <p class="py-0">Coming Soon</p>
                            </b-tab>
                            <b-tab title="Category" to="#category"><p>Coming Soon</p></b-tab>
                            <b-tab title="Product Steps" to="#steps" active>
                                <!--------------------------------------- PRODUCT STEPS --------------------------------->
                                <b-row class="mt-3 mb-2">
                                    <b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
                                        <p class="my-0">Product steps</p>
                                    </b-col>
                                    <b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
                                        <b-button variant="dark" size="sm" pill @click="showAddStepModal()"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add Step</b-button>
                                    </b-col>
                                </b-row>
                                <b-table show-empty sticky-header small striped outlined class="text-left" id="my-table" stacked="md" :items="productstepitems" :fields="productstepfields">
                                    <template v-slot:cell(title)="row">
										<div v-if="row.item.parent == 0">{{ row.value }}</div>
										<div class="ml-4" v-else>{{row.value}}</div>
									</template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1" @click="showUpdateStepModal(row.item, row.index, $event.target)" size="sm"><b-icon class="mr-2" icon="pencil" aria-hidden="true"></b-icon>Edit</b-button>
										<b-button pill variant="danger" class="mr-1" @click="showStepDeleteModal(row.item)" size="sm"><b-icon class="mr-2" icon="trash" aria-hidden="true"></b-icon>Delete</b-button>
										<b-button pill variant="primary" class="mr-1" @click="showAddStepFieldModal(row.item)" v-if="row.item.parent==0" size="sm"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add Field</b-button>
									</template>
								</b-table>
                                <!--------------------------------------- PRODUCT STEPS --------------------------------->
                            </b-tab>
							<b-tab title="Product Options" to="#steps" active>
                                <!-------------------------------------- PRODUCT OPTIONS -------------------------------->
                                <b-row class="mt-3 mb-2">
                                    <b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
                                        
                                    </b-col>
                                    <b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
										<label class="mt-2 pb-0 mr-2 mb-0" style="display:inline-block; width:100px;">Enable</label>
										<b-form-select v-model="enable_option" class="mt-2 mr-4" style="width:100px">
											<b-form-select-option value="1">Yes</b-form-select-option>
											<b-form-select-option value="0">No</b-form-select-option>
										</b-form-select>
                                        <b-button class="mt-2 mr-2" variant="dark" size="sm" pill @click="addStyleModal()"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add Style</b-button>
										<b-button class="mt-2" variant="dark" size="sm" pill @click="saveProductOptions()"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Save</b-button>
                                    </b-col>
                                </b-row>
								<div v-for="(style, index) in productoptions.children" :key="style.id" class="product-options p-1 m-2" style="border-bottom:1px solid #ddd;">
									<b-row class="mb-2">
										<b-col md="2">
											<p class="m-0 p-0">Title</p>
											<b-form-input v-model="style.title" size="sm" required></b-form-input>
										</b-col>
										<!--<b-col md="2">
											<p class="m-0 p-0">Position</p>
											<b-form-input v-model="style.position" size="sm" required></b-form-input>
										</b-col>-->
										<b-col md="2">
										</b-col>
										<b-col md="3">
											<b-button class="mt-2 mr-2" pill variant="info" @click="addMeshModal(style.meshes)" size="sm"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add Mesh</b-button>
											<b-button class="mt-2" pill variant="info" @click="deleteItem(productoptions.children, index)" size="sm"><b-icon class="mr-2" icon="trash" aria-hidden="true"></b-icon>Delete</b-button>
										</b-col>
									</b-row>
									<div v-for="(mesh, index2) in style.meshes" :key="mesh.id" class="ml-5">
										<b-row class="mb-2">
											<b-col md="2">
												<p class="m-0 p-0">Title</p>
												<b-form-input v-model="mesh.title" size="sm" required></b-form-input>
											</b-col>
											<b-col md="2">
												<p class="m-0 p-0">Code</p>
												<b-form-input v-model="mesh.code" size="sm" required></b-form-input>
											</b-col>
											<b-col md="2">
												<p class="m-0 p-0">Selected</p>
												<b-form-input v-model="mesh.mesh" size="sm" required></b-form-input>
											</b-col>
											<!--<b-col md="2">
												<p class="m-0 p-0">Position</p>
												<b-form-input v-model="mesh.position" size="sm" required></b-form-input>
											</b-col>-->
											<b-col md="3">
												<b-button class="mt-2 mr-2" pill variant="info" @click="addOptionModal(mesh.children)" size="sm"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add Option</b-button>
												<b-button class="mt-2" pill variant="info" @click="deleteItem(style.meshes, index2)" size="sm"><b-icon class="mr-2" icon="trash" aria-hidden="true"></b-icon>Delete</b-button>
											</b-col>
										</b-row>
										<div v-for="(option, index3) in mesh.children" :key="option.id" class="ml-5">
											<b-row class="mb-2">
												<b-col md="2">
													<p class="m-0 p-0">Title</p>
													<b-form-input v-model="option.title" size="sm" required></b-form-input>
												</b-col>
												<b-col md="2">
													<p class="m-0 p-0">Code</p>
													<b-form-input v-model="option.code" size="sm" required></b-form-input>
												</b-col>
												<!--<b-col md="2">
													<p class="m-0 p-0">Position</p>
													<b-form-input v-model="option.position" size="sm" required></b-form-input>
												</b-col>-->
												<b-col md="3">
													<b-button class="mt-2" pill variant="info" @click="deleteItem(mesh.children, index3)" size="sm"><b-icon class="mr-2" icon="trash" aria-hidden="true"></b-icon>Delete</b-button>
												</b-col>
											</b-row>
										</div>
									</div>
								</div>
                                <!-------------------------------------- PRODUCT OPTIONS -------------------------------->
                            </b-tab>
                            <b-tab title="Product Artworks">
                                <!-------------------------------------- PRODUCT ARTWORKS --------------------------------->
                                <b-row class="mt-3 mb-2">
                                    <b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
                                        <p class="my-0">Product Artworks (Under development...)</p>
                                    </b-col>
                                    <b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
                                        <b-button variant="dark" size="sm" pill @click="showAddArtworkModal()"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add Artwork</b-button>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-3">
                                    <b-col lg="6" class="text-left">
                                        <span class="mr-2">Show</span>
                                        <b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
                                        </b-form-select>
                                        <span class="ml-2">entries</span>
                                    </b-col>
                                    <b-col lg="4" offset-md="2">
                                        <b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
                                            <b-input-group size="sm">
                                                <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
                                                </b-form-input>
                                                <b-input-group-append>
                                                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-3">
                                    <b-col lg="12">
                                        <b-table show-empty sticky-header small striped outlined id="my-table" class="text-left" stacked="md" :items="records" :fields="artworkfields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
                                            <template v-slot:cell(title)="row">
                                                <div v-if="row.item.parent == 0">{{ row.value }}</div>
                                                <div class="ml-3" v-else>{{row.value}}</div>
                                            </template>
                                            <template v-slot:cell(image)="row">
                                                <b-img v-bind="thumbnailProps" rounded alt="" v-if="row.value==''" src="../assets/icons/blank.svg">{{row}}</b-img>
                                                <b-img v-bind="thumbnailProps" rounded alt="" v-else :src="$root.MEDIAPATH+$session.get('user_info').uniq_id+'/products/'+row.item.product_id+'/artworks/'+row.value">{{row}}</b-img>
                                            </template>
                                            <template v-slot:cell(actions)="row">
                                                <b-button pill variant="primary" class="mr-1" @click="showUpdateArtworkModal(row.item, row.index, $event.target)" size="sm"><b-icon class="mr-2" icon="pencil" aria-hidden="true"></b-icon>Edit</b-button>
                                                <b-button pill variant="danger" class="mr-1" @click="showDeleteModal(row.item)" size="sm"><b-icon class="mr-2" icon="trash" aria-hidden="true"></b-icon>Delete</b-button>
                                                <b-button pill variant="primary" class="mr-3" :href="'/dyo/artwork/'+row.item.artwork_id" size="sm"><b-icon class="mr-2" icon="image" aria-hidden="true"></b-icon>Fields</b-button>
												<b-button pill variant="info" class="mr-1" @click="cloneArtwork(row.item)" size="sm"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Clone</b-button>
											</template>
                                        </b-table>
                                    </b-col>
                                </b-row>
                                <b-row class="">
                                    <b-col lg="6" class="text-left">
                                        <span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
                                    </b-col>
                                    <b-col lg="3" offset-md="3">
                                        <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
                                    </b-col>
                                </b-row>
                                <!-------------------------------------- PRODUCT ARTWORKS --------------------------------->
                            </b-tab>
							<b-tab title="Product Fields">
								<!--------------------------------------- PRODUCT FIELD --------------------------------->
                                <b-row class="mt-3 mb-2">
                                    <b-col class="col-md-6 col-sm-6 col-xs-6 text-left tab-content">
										<h5 class="mb-0 f-sb">Product Fields</h5>
                                        <p class="my-0">These fields are unique to each product and are used for all designs of this product.</p>
                                    </b-col>
                                    <b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
                                        <b-button variant="dark" size="sm" pill @click="showAddProductFieldModal()"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add Product Field</b-button>
                                    </b-col>
                                </b-row>
                                <b-table show-empty sticky-header small striped outlined class="text-left" id="tierprice-table" stacked="md" :items="productfielditems" :fields="productfieldfields">
                                    <template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1" @click="showUpdateProductFieldModal(row.item, row.index, $event.target)" size="sm"><b-icon class="mr-2" icon="pencil" aria-hidden="true"></b-icon>Edit</b-button>
										<b-button pill variant="danger" class="mr-1" @click="showProductFieldDeleteModal(row.item)" size="sm"><b-icon class="mr-2" icon="trash" aria-hidden="true"></b-icon>Delete</b-button>
									</template>
								</b-table>
                                <!--------------------------------------- PRODUCT FIELD --------------------------------->
							</b-tab>
							<b-tab title="Embellishments">
                                <!-------------------------------------- PRODUCT EMBLESHMENT --------------------------------->
                                <b-row class="mt-3 mb-2">
                                    <b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
                                        <p class="my-0">Embellishments</p>
                                    </b-col>
                                    <b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
                                        <b-button variant="dark" size="sm" pill @click="showAddEmbellishmentModal()"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add Embellishment</b-button>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-3">
                                    <b-col lg="6" class="text-left">
                                        <span class="mr-2">Show</span>
                                        <b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
                                        </b-form-select>
                                        <span class="ml-2">entries</span>
                                    </b-col>
                                    <b-col lg="4" offset-md="2">
                                        <b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
                                            <b-input-group size="sm">
                                                <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
                                                </b-form-input>
                                                <b-input-group-append>
                                                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-3">
                                    <b-col lg="12">
                                        <b-table show-empty sticky-header small striped outlined id="my-table" class="text-left" stacked="md" :items="embellishmentrecords" :fields="embellishmentfields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
                                            <template v-slot:cell(title)="row">
                                                <div v-if="row.item.parent == 0">{{ row.value }}</div>
                                                <div class="ml-3" v-else>{{row.value}}</div>
                                            </template>
                                            <template v-slot:cell(image)="row">
                                                <b-img v-bind="thumbnailProps" rounded alt="" v-if="row.value==''" src="../assets/icons/blank.svg">{{row}}</b-img>
                                                <b-img v-bind="thumbnailProps" rounded alt="" v-else :src="$root.MEDIAPATH+$session.get('user_info').uniq_id+'/products/'+row.item.product_id+'/embellishment/'+row.value">{{row}}</b-img>
                                            </template>
                                            <template v-slot:cell(actions)="row">
                                                <b-button pill variant="primary" class="mr-1" @click="showUpdateEmbellishmentModal(row.item, row.index, $event.target)" size="sm"><b-icon class="mr-2" icon="pencil" aria-hidden="true"></b-icon>Edit</b-button>
                                                <b-button pill variant="danger" class="mr-1" @click="showDeleteEmbellishmentModal(row.item)" size="sm"><b-icon class="mr-2" icon="trash" aria-hidden="true"></b-icon>Delete</b-button>
                                            </template>
                                        </b-table>
                                    </b-col>
                                </b-row>
                                <b-row class="">
                                    <b-col lg="6" class="text-left">
                                        <span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
                                    </b-col>
                                    <b-col lg="3" offset-md="3">
                                        <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
                                    </b-col>
                                </b-row>
                                <!-------------------------------------- PRODUCT EMBLESHMENT --------------------------------->
                            </b-tab>
							<b-tab title="Tier Price">
								<!--------------------------------------- PRODUCT TIER PRICE --------------------------------->
                                <b-row class="mt-3 mb-2">
                                    <b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
                                        <p class="my-0">Product Tier Price</p>
                                    </b-col>
                                    <b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
                                        <b-button variant="dark" size="sm" pill @click="showAddTierPriceModal()"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add Tier Price</b-button>
									</b-col>
                                </b-row>
                                <b-table show-empty sticky-header small striped outlined class="text-left" id="tierprice-table" stacked="md" :items="producttierpriceitems" :fields="producttierpricefields">
                                    <template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1" @click="showUpdateTierPriceModal(row.item, row.index, $event.target)" size="sm"><b-icon class="mr-2" icon="pencil" aria-hidden="true"></b-icon>Edit</b-button>
										<b-button pill variant="danger" class="mr-1" @click="showTierPriceDeleteModal(row.item)" size="sm"><b-icon class="mr-2" icon="trash" aria-hidden="true"></b-icon>Delete</b-button>
									</template>
								</b-table>
                                <!--------------------------------------- PRODUCT TIER PRICE --------------------------------->
							</b-tab>
							<b-tab title="Product Artwork Colors" :title-link-class="onSelectTab()">
								<b-row class="mt-3 mb-2">
									<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
										<p class="my-0">Product Artwork Colors</p>
									</b-col>
									<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
										<b-button variant="dark" size="sm" pill @click="saveArtworkColors()"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Save</b-button>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										<b-button size="sm" @click="selectAllRows">Select all</b-button>
										<b-button size="sm" @click="clearSelected">Clear selected</b-button>
									</b-col>
								</b-row>
								<b-table ref="colortable" show-empty selectable sticky-header small striped outlined id="my-table" @row-selected="onColorRowSelected" select-mode="multi" class="text-left" stacked="md" :items="productartworkcoloritems" :fields="productartworkcolorfields">
									<template v-slot:cell(title)="row">
										<div v-if="row.item.parent == 0">{{ row.value }}</div>
										<div class="ml-3" v-else>{{row.value}}</div>
									</template>
									<template #cell(productcolorselected)="{ rowSelected }">
										<template v-if="rowSelected">
											<span aria-hidden="true"><b-icon stacked icon="check" style="width:16px"></b-icon></span>
											<span class="sr-only">Selected</span>
										</template>
										<template v-else>
											<span aria-hidden="true">&nbsp;</span>
											<span class="sr-only">Not selected</span>
										</template>
									</template>
									<template v-slot:cell(actions)="row">
										<b-form-checkbox v-model="status" :name="'cb-'+row.item.id" :value="row.item.id" unchecked-value=""></b-form-checkbox>
									</template>
								</b-table>
							</b-tab>
							<b-tab title="Logo Positions">
                                <!-------------------------------------- PRODUCT POSITONS --------------------------------->
                                <b-row class="mt-3 mb-2">
                                    <b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
                                        <p class="my-0">Logo Positions</p>
                                    </b-col>
                                    <b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
                                        <b-button variant="dark" size="sm" pill class="mr-2" @click="importmaster()"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Import Master</b-button>
										<b-button variant="dark" size="sm" pill class="mr-2" @click="addLogoposition()"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add Position</b-button>
										<b-button variant="dark" size="sm" pill @click="saveLogoposition()"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Save</b-button>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-3">
                                    <b-col lg="3">
										
									</b-col>
									<b-col lg="3">
									</b-col>
								</b-row>
                                <b-row class="mt-3">
                                    <b-col lg="12">
										<b-row>
											<b-col cols="auto">
												<p class="text-left">ID</p>
											</b-col>
											<b-col cols="2">
												<p>Title</p>
											</b-col>
											<b-col>
												<p>Area X</p>
											</b-col>
											<b-col>
												<p>Area Y</p>
											</b-col>
											<b-col>
												<p>Area Width</p>
											</b-col>
											<b-col>
												<p>Area Height</p>
											</b-col>
											<b-col cols="auto">
											</b-col>
										</b-row>
										<div v-for="(item) in positions" :key="item.id">
											
											<b-row>
												<b-col cols="auto">
													<p class="text-left" style="width:30px">{{item.id}}</p>
												</b-col>
												<b-col cols="2">
													<b-form-input id="input-small" size="sm" v-model="item.title" placeholder=""></b-form-input>
												</b-col>
												<b-col cols="2">
													<b-form-input id="input-small" size="sm" v-model="item.area[0]" placeholder="X"></b-form-input>
												</b-col>
												<b-col cols="2">
													<b-form-input id="input-small" size="sm" v-model="item.area[1]" placeholder="Y"></b-form-input>
												</b-col>
												<b-col cols="2">
													<b-form-input id="input-small" size="sm" v-model="item.area[2]" placeholder="Width"></b-form-input>
												</b-col>
												<b-col cols="2">
													<b-form-input id="input-small" size="sm" v-model="item.area[3]" placeholder="Height"></b-form-input>
												</b-col>
												<b-col cols="auto" class="text-right">
													<b-button pill variant="danger" class="mr-1" @click="deleteLogoPosition(row)" size="sm"><b-icon class="mr-2" icon="trash" aria-hidden="true"></b-icon>Delete</b-button>
												</b-col>
											</b-row>
										</div>
                                        <b-table show-empty sticky-header small striped outlined id="my-table" class="text-left" stacked="md" :items="positions" :fields="logopositions">
											<template v-slot:cell(apply)="row">
                                                <div><b-form-checkbox id="checkbox-1" v-model="row.item.apply" name="checkbox-1" value="accepted" unchecked-value="not_accepted"></b-form-checkbox></div>
                                            </template>
											<template v-slot:cell(title)="row">
                                                <div><b-form-input id="input-small" size="sm" :value="row.item.title" placeholder=""></b-form-input></div>
                                            </template>
                                            <template v-slot:cell(area)="row">
												<b-row>
													<b-col>
														<b-form-input id="input-small" size="sm" :value="row.item.area[0]" placeholder="X"></b-form-input>
													</b-col>
													<b-col>
														<b-form-input id="input-small" size="sm" :value="row.item.area[1]" placeholder="Y"></b-form-input>
													</b-col>
													<b-col>
														<b-form-input id="input-small" size="sm" :value="row.item.area[2]" placeholder="Width"></b-form-input>
													</b-col>
													<b-col>
														<b-form-input id="input-small" size="sm" :value="row.item.area[3]" placeholder="Height"></b-form-input>
													</b-col>
												</b-row>
                                            </template>
                                            <template v-slot:cell(action)="row">
                                                <b-button pill variant="danger" class="mr-1" @click="deleteLogoPosition(row)" size="sm"><b-icon class="mr-2" icon="trash" aria-hidden="true"></b-icon>Delete</b-button>
                                            </template>
                                        </b-table>
                                    </b-col>
                                </b-row>
                                <!-------------------------------------- END LOGO POSITIONS --------------------------------->
                            </b-tab>
						</b-tabs>
                    </div>
				</b-col>
			</b-row>

			<b-modal id="step-model" :title="(selectedItem.id > 0)?((selectedItem.parent>0)?'Edit Field':'Edit Step'):((selectedItem.parent>0)?'Add Field':'Add Step')" size="sm" ok-only @hidden="resetSelectedItem" @ok="modalStepSubmit">
                <b-container fluid>
					<b-row class="mb-1">
                        <b-col cols="12">
                            <form ref="form" @submit.stop.prevent="modalStepSubmit">
                                <b-row class="mb-3">
									<b-col cols="3" class="text-right"><label class="font-sm">Title</label></b-col>
									<b-col><b-form-input v-model="selectedItem.title" size="sm" required></b-form-input></b-col>
								</b-row>
                                <b-row class="mb-3">
									<b-col cols="3" class="text-right"><label class="font-sm">Position</label></b-col>
									<b-col><b-form-input v-model="selectedItem.position" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-button type="submit" size="sm" style="display:none;">SUBMIT HANDLER</b-button>
                            </form>
							<!-- @keydown.enter.native="handleStepSubmit"-->
                        </b-col>
					</b-row>
                </b-container>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
			<b-modal id="artwork-model" :title="(selectedItem.id > 0)?'Edit Artwork':'Add Artwork'" ok-only @hidden="resetSelectedItem" @ok="modalArtworkSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-form-group label="Title" label-cols="3" label-size="sm" label-align-sm="right" invalid-feedback="Title is required">
						<b-form-input v-model="selectedItem.title" required></b-form-input>
					</b-form-group>
					<b-form-group label="Sku" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-input v-model="selectedItem.sku"></b-form-input>
					</b-form-group>
                    <b-form-group label="Image" label-cols="3" label-size="sm" label-align-sm="right">
                        <b-form-file type="file" v-model="artwork_image" accept=".jpeg,.jpg,.png" placeholder="Choose a image or drop it here..."></b-form-file>
                        <b-form-text id="password-help-block">{{selectedItem.image}}</b-form-text>
					</b-form-group>
                    <b-form-group label="SVG" label-cols="3" label-size="sm" label-align-sm="right"><!-- v-if="selectedItem.art_file == ''"-->
                        <b-form-file type="file" v-model="artwork_art_file" accept=".svg" placeholder="Choose a svg or drop it here..."></b-form-file>
                        <b-form-text id="password-help-block">{{selectedItem.art_file}}</b-form-text>
					</b-form-group>
					<b-form-group label="cart Price" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-input v-model="selectedItem.price" placeholder="eq. 1.99"></b-form-input>
					</b-form-group>
					<b-form-group label="Position" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-input v-model="selectedItem.position" placeholder="eq. 10"></b-form-input>
					</b-form-group>
					<b-form-group label="Status" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-select v-model="selectedItem.status" :options="$root.status_options" required></b-form-select>
					</b-form-group>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
			<b-modal id="embellishment-model" :title="(selectedItem.id > 0)?'Edit Embellishment':'Add Embellishment'" ok-only @hidden="resetSelectedItem" @ok="modalEmbellishmentSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-form-group label="Title" label-cols="3" label-size="sm" label-align-sm="right" invalid-feedback="Title is required">
						<b-form-input v-model="selectedItem.title" required></b-form-input>
					</b-form-group>
					<b-form-group label="Image" label-cols="3" label-size="sm" label-align-sm="right">
                        <b-form-file type="file" v-model="artwork_image" accept=".jpeg,.jpg,.png" placeholder="Choose a image or drop it here..."></b-form-file>
                        <b-form-text id="password-help-block">{{selectedItem.image}}</b-form-text>
					</b-form-group>
                    <b-form-group label="SVG" label-cols="3" label-size="sm" label-align-sm="right" ><!--v-if="selectedItem.art_file == ''"-->
                        <b-form-file type="file" v-model="artwork_art_file" accept=".svg" placeholder="Choose a svg or drop it here..."></b-form-file>
                        <b-form-text id="password-help-block">{{selectedItem.art_file}}</b-form-text>
					</b-form-group>
					<b-form-group label="Position" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-input v-model="selectedItem.position" placeholder="eq. 10"></b-form-input>
					</b-form-group>
					<b-form-group label="Status" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-select v-model="selectedItem.status" :options="$root.status_options" required></b-form-select>
					</b-form-group>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
			<b-modal id="tierprice-model" :title="(selectedItem.id > 0)?'Edit Tier Price':'Add Tier Price'" size="sm" ok-only @hidden="resetSelectedItem" @ok="modalTierPriceSubmit">
                <b-container fluid>
					<b-row class="mb-1">
                        <b-col cols="12">
                            <form ref="form" @submit.stop.prevent="modalTierPriceSubmit">
                                <b-row class="mb-3">
									<b-col cols="6" class="text-right"><label class="font-sm">Min Quantity</label></b-col>
									<b-col><b-form-input v-model="selectedItem.min_qty" size="sm" required></b-form-input></b-col>
								</b-row>
                                <b-row class="mb-3">
									<b-col cols="6" class="text-right"><label class="font-sm">Unit Price</label></b-col>
									<b-col><b-form-input v-model="selectedItem.unit_price" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="6" class="text-right"><label class="font-sm">Fixed Disount</label></b-col>
									<b-col><b-form-input v-model="selectedItem.fixed_discount" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="6" class="text-right"><label class="font-sm">Percent Discount</label></b-col>
									<b-col><b-form-input v-model="selectedItem.percent_discount" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-button type="submit" size="sm" style="display:none;">SUBMIT HANDLER</b-button>
                            </form>
							<!-- @keydown.enter.native="handleStepSubmit"-->
                        </b-col>
					</b-row>
                </b-container>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
			<b-modal id="productfield-model" :title="(selectedFieldItem.id > 0)?'Edit Field':'Add Field'" size="md" ok-only @hidden="resetSelectedItem" @ok="modalProductFieldSubmit">
                <b-container fluid>
					<b-row class="mb-1">
                        <b-col cols="12">
                            <form ref="form" @submit.stop.prevent="modalFieldSubmit">
                                <b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Step</label></b-col>
									<b-col>
										<b-form-select v-model="selectedFieldItem.step_id" size="sm" :options="productstepitems">
                                        </b-form-select>
									</b-col>
								</b-row>
                                <b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Type</label></b-col>
									<b-col>
										<b-form-select v-model="selectedFieldItem.type" size="sm">
											<b-form-select-option value="DROPDOWN">Dropdown</b-form-select-option>
											<b-form-select-option value="TEAMDETAILS">Team Details</b-form-select-option>
											<b-form-select-option value="TEXTAREA">Textarea</b-form-select-option>
										</b-form-select>
									</b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Title</label></b-col>
									<b-col><b-form-input v-model="selectedFieldItem.title" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Description</label></b-col>
									<b-col><b-form-textarea v-model="selectedFieldItem.description" size="sm" rows="2" max-rows="6"></b-form-textarea></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Key</label></b-col>
									<b-col><b-form-input v-model="selectedFieldItem.key_id" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Data Source</label></b-col>
									<b-col>
										<b-form-select v-model="selectedFieldItem.data_source_id" size="sm" :options="datasource" @change="onChangeDataSource()">
                                        </b-form-select>
									</b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Default</label></b-col>
									<b-col>
										<b-form-select v-model="selectedFieldItem.selected_data" size="sm" value-field="id" text-field="title" :options="datasourcefields">
                                        </b-form-select>
									</b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Show Quantity</label></b-col>
									<b-col>
										<b-form-checkbox v-model="selectedFieldItem.field_data.show_quantity" size="sm" value="1"></b-form-checkbox>
									</b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Show Team and Player details</label></b-col>
									<b-col><b-form-checkbox v-model="selectedFieldItem.field_data.show_teams" size="sm" value="1"></b-form-checkbox></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Position</label></b-col>
									<b-col><b-form-input v-model="selectedFieldItem.position" size="sm"></b-form-input></b-col>
								</b-row>
								<b-button type="submit" size="sm" style="display:none;">SUBMIT HANDLER</b-button>
                            </form>
							<!-- @keydown.enter.native="handleStepSubmit"-->
                        </b-col>
					</b-row>
                </b-container>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedFieldItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
			loading: true, 
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Products',
					href: '/dyo/products'
				},
				{
					text: '',
					active: true
				}
			],
			enable_option: 1,
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            artwork_image: [],
            artwork_art_file: [],
			recordUrl: this.$root.WEBAPI+'product-fetch',
			productOptionUpdateUrl: this.$root.WEBAPI+'productoption-update',
            productstepInsertUrl: this.$root.WEBAPI+'productstep-insert',
            productstepUpdateUrl: this.$root.WEBAPI+'productstep-update',
            productstepDeleteUrl: this.$root.WEBAPI+'productstep-delete',
			insertUrl: this.$root.WEBAPI+'artwork-insert',
			cloneUrl: this.$root.WEBAPI+'artwork-clone',
			updateUrl: this.$root.WEBAPI+'artwork-update',
			deleteUrl: this.$root.WEBAPI+'artwork-delete',
			csvgenUrl: this.$root.WEBAPI+'dyo-gencsv',
			productTierPriceInsertUrl: this.$root.WEBAPI+'producttierprice-insert',
            productTierPriceUpdateUrl: this.$root.WEBAPI+'producttierprice-update',
			productTierPriceDeleteUrl: this.$root.WEBAPI+'producttierprice-delete',
			productFieldInsertUrl: this.$root.WEBAPI+'productfield-insert',
            productFieldUpdateUrl: this.$root.WEBAPI+'productfield-update',
			productFieldDeleteUrl: this.$root.WEBAPI+'productfield-delete',
			productColorRecordtUrl: this.$root.WEBAPI+'artworkcolors-record',
			productColorInsertUrl: this.$root.WEBAPI+'productcolor-insert',
            productColorUpdateUrl: this.$root.WEBAPI+'productcolor-update',
            productColorDeleteUrl: this.$root.WEBAPI+'productcolor-delete',
			logopositionUpdateUrl: this.$root.WEBAPI+'logoposition-update',
			embellishmentrecordUrl: this.$root.WEBAPI+'embellishment-record',
			embellishmentinsertUrl: this.$root.WEBAPI+'embellishment-insert',
			embellishmentupdateUrl: this.$root.WEBAPI+'embellishment-update',
			embellishmentdeleteUrl: this.$root.WEBAPI+'embellishment-delete',
            productdata: {},
			records: [],
			datasource: [],
			datasourcefields: [],
			productstepitems: [],
			productoptions: {
				index: 0,
				children: []
			},
			productfielditems: [],
			producttierpriceitems: [],
			productartworkcoloritems: [],
			productcolorselected: [],
			statusOptions: [{ value: 0, text: 'Disabled' },{ value: 1, text: 'Enabled' }],
            categoryOptions: [],
			positions: [],
			posindex: 1,
            productstepfields: [
                { key: 'id', label: 'ID'},
				{ key: 'title', label: 'Title'},
                { key: 'position', label: 'Position' },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
			],
			producttierpricefields: [
                { key: 'id', label: 'ID'},
				{ key: 'min_qty', label: 'Min Quantitly'},
				{ key: 'unit_price', label: 'Unit Price' },
				{ key: 'fixed_discount', label: 'Fixed Discount' },
				{ key: 'percent_discount', label: 'Percent Discount' },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
			],
			productstylefields: [
                { key: 'id', label: 'ID'},
				{ key: 'title', label: 'Title'},
				{ key: 'code', label: 'Code' },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
			],
			productartworkcolorfields: [
                { key: 'id', label: 'ID'},
				{ key: 'title', label: 'Title'},
				{ key: 'hexcode', label: 'Hexcode' },
				{ key: 'productcolorselected', label: 'Selected', 'extra': 1 }
			],
			logopositions: [
				{ key: 'id', label: 'ID'},
				{ key: 'title', label: 'Title'},
				{ key: 'area', label: 'Area (x, y, width, height)' },
				{ key: 'action', label: 'Actions'}
			],
			productfieldfields:[
				{ key: 'id', label: 'ID'},
				{ key: 'key_id', label: 'Key'},
				{ key: 'title', label: 'Name' },
				{ key: 'step_id', label: 'Step',
					formatter: (value) => {
						for(var i=0; i<this.productstepitems.length; i++){
							//console.log(this.productstepitems[i].value+" "+value);
							if(this.productstepitems[i].id == value){
								return this.productstepitems[i].title;
							}
						}
					},
				},
				{ key: 'type', label: 'Type' },
				{ key: 'data_source_id', label: 'Data Source',
					formatter: (value) => {
						for(var i=0; i<this.datasource.length; i++){
							if(this.datasource[i].value == value){
								return this.datasource[i].text;
							}
						}
					},
				},
				{ key: 'selected_data', label: 'Default',
					formatter: (value, index, item) => {
						for(var i=0; i<this.datasource.length; i++){
							if(this.datasource[i].value == item.data_source_id){
								var fields = JSON.parse(this.datasource[i].field_data);
								for(var j=0; j<fields.length; j++){
									if(fields[j].id == value){
										return fields[j].title;
									}
								}
							}
						}
					},
				},
				{ key: 'position', label: 'Position' },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
			],
			artworkfields: [
				{ key: 'id', label: 'ID'},
				{ key: 'title', label: 'Title'},
				{ key: 'sku', label: 'Sku' },
				{ key: 'image', label: 'Image' },
                { key: 'price', label: 'Price' },
                { key: 'position', label: 'Position' },
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
			],

			embellishmentfields: [
				{ key: 'id', label: 'ID'},
				{ key: 'title', label: 'Title'},
				{ key: 'image', label: 'Image' },
                { key: 'position', label: 'Position' },
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
            selectedItem: {},
            selectedFieldItem: {field_data: {}},
			emptyItem: {
				id: 0,
                product_id: '',
                image: '',
                art_file: '',
				title: '',
				sku: '',
				position: 0,
                price: 0.00,
                status: 0
            },
            emptyStepItem: {
                id: 0,
                title: '',
                position: 0,
			},
			emptytierpriceItem: {
                id: 0,
				min_qty: 0,
				unit_price: '',
				fixed_discount: '',
				percent_discount: ''
			},
			emptyProductFieldItem: {
				id: 0,
				product_id: '',
				step_id: '',
				type: '',
				title: '',
				description: '',
				key_id: '',
				data_source_id: '',
				selected_data: '',
				field_data: {},
				position: ''
			}
		};
	},
	methods: {
		cloneArtwork(item){
			var self = this;
			self.loading = true;
			
            
            let formData = new FormData();
            formData.append('data', JSON.stringify(item));
            formData.append('accesskey', this.$session.get('access_key'));
            
			self.axios.post(self.cloneUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//self.$bvModal.hide('artwork-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		importmaster(){
			if(this.positions.length == 0){
				this.loadMasterSVG();
			}
		},
		addLogoposition(){
			this.positions.push({id:this.posindex++, label:'', area:['','','',''], action:''});
		},
		deleteLogoPosition(row){
			this.positions.splice(row.index, 1);
		},
		saveLogoposition(){
			var self = this;
			self.axios.post(self.logopositionUpdateUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.positions,
				product_id: self.$route.params.product_id
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvToast.toast(response.data.message, {
						title: 'Delete',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					//self.positions = response.data.result;
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		selectAllRows() {
			this.$refs.colortable.selectAllRows()
		},
		clearSelected() {
			this.$refs.colortable.clearSelected()
		},
		onColorRowSelected(items){
			//console.log("ROW SELECTED "+JSON.stringify(items));
			this.productcolorselected = items;
		},
		onSelectTab: function(){
			var self = this;
			setTimeout(function(){
				var color_data;
				
				if(self.productdata.color_data){
					color_data = JSON.parse(self.productdata.color_data);
				}else{
					color_data = new Array();
				}
				var index = 0;
				self.productartworkcoloritems.forEach(function(field){
					if(color_data.indexOf(field.id) >=0 ){
						if(self.$refs.colortable){
							self.$refs.colortable.selectRow(index);
						}
						
					}
					index++;
				});
			}, 1000);
		},
		onSelectTab2: function(){
			var self = this;
			//alert(JSON.parse(self.productdata.color_data));
			
			var color_data;
			
			if(self.productdata.color_data){
				color_data = JSON.parse(self.productdata.color_data);
			}else{
				color_data = new Array();
			}
			var index = 0;
			self.productartworkcoloritems.forEach(function(field){
				if(color_data.indexOf(field.id) >=0 ){
					if(self.$refs.colortable){
						self.$refs.colortable.selectRow(index);
					}
					
				}
				index++;
			});
		},
		saveArtworkColors: function(){
			var self = this;
			var color_data = [];
			self.productcolorselected.forEach(function(field){
				color_data.push(field.id);
			});
			self.axios.post(self.productColorUpdateUrl, {
				accesskey: self.$session.get('access_key'),
				data: color_data,
				product_id: self.$route.params.product_id
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvToast.toast(response.data.message, {
						title: 'Delete',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.producttierpriceitems = response.data.result;
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		onChangeDataSource: function(){
			//console.log('>>>> '+this.datasource.length);
			for(var i=0; i<this.datasource.length; i++){
				if(this.datasource[i].value == this.selectedFieldItem.data_source_id){
					this.datasourcefields = JSON.parse(this.datasource[i].field_data);
					break;
				}
			}
		},
		handleStepSubmit: function(e) {
			alert(e.keyCode);
			if (e.keyCode === 13) {
				alert('Enter was pressed');
			} else if (e.keyCode === 50) {
				alert('@ was pressed');
			}
		},
		showAddArtworkModal(){
            this.selectedItem = Object.assign({}, this.emptyItem);
            this.selectedItem.product_id = this.$route.params.product_id;
            this.selectedItem.artwork_id = '';
			this.$root.$emit('bv::show::modal', 'artwork-model');
        },
		showAddEmbellishmentModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
            this.selectedItem.product_id = this.$route.params.product_id;
            this.selectedItem.embellishment_id = '';
			this.$root.$emit('bv::show::modal', 'embellishment-model');
		},
        showAddStepModal(){
            this.selectedItem = Object.assign({}, this.emptyStepItem);
            this.selectedItem.product_id = this.$route.params.product_id;
            this.selectedItem.parent = 0;
			this.$root.$emit('bv::show::modal', 'step-model');
		},
		showAddTierPriceModal(){
			this.selectedItem = Object.assign({}, this.emptytierpriceItem);
			this.selectedItem.product_id = this.$route.params.product_id;
			this.selectedItem.id = 0;
			this.$root.$emit('bv::show::modal', 'tierprice-model');
        },
        showAddStepFieldModal(item){
            this.selectedItem = Object.assign({}, this.emptyStepItem);
			this.selectedItem.product_id = this.$route.params.product_id;
			this.selectedItem.parent = item.id;
			this.selectedItem.id = 0;
			this.$root.$emit('bv::show::modal', 'step-model');
		},
		showAddProductFieldModal(){
			this.selectedFieldItem = Object.assign({}, this.emptyProductFieldItem);
			this.selectedFieldItem.product_id = this.$route.params.product_id;
			this.selectedFieldItem.id = 0;
			this.onChangeDataSource();
			this.$root.$emit('bv::show::modal', 'productfield-model');
		},
		showUpdateArtworkModal(item, index, button){
			this.selectedItem = Object.assign({}, item);
            this.selectedItem.product_id = this.$route.params.product_id;
            this.$root.$emit('bv::show::modal', 'artwork-model', button);
		},
		showUpdateEmbellishmentModal(item, index, button){
			this.selectedItem = Object.assign({}, item);
            this.selectedItem.product_id = this.$route.params.product_id;
            this.$root.$emit('bv::show::modal', 'embellishment-model', button);
		},
		showUpdateStepModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			
			this.$root.$emit('bv::show::modal', 'step-model', button)
		},
		showUpdateTierPriceModal(item, index, button){
			this.selectedItem = Object.assign({}, item);
            this.selectedItem.product_id = this.$route.params.product_id;
            this.$root.$emit('bv::show::modal', 'tierprice-model', button);
		},
		showUpdateProductFieldModal(item){
			this.selectedFieldItem = Object.assign({}, item);
			this.selectedFieldItem.product_id = this.$route.params.product_id;
			if(item.field_data){
				this.selectedFieldItem.field_data = JSON.parse(item.field_data);
			}
			this.onChangeDataSource();
			this.$root.$emit('bv::show::modal', 'productfield-model');
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete artwork!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.artwork_id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		showDeleteEmbellishmentModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete embellishment!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.embellishmentdeleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		
		showTierPriceDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete tier Price!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.productTierPriceDeleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.id,
						product_id: this.$route.params.product_id
					})

					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.producttierpriceitems = response.data.result;
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
        },
        


        showStepDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete step!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.productstepDeleteUrl, {
						accesskey: self.$session.get('access_key'),
                        delete_id: item.id,
                        product_id: item.product_id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.productstepitems = response.data.result;
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		saveProductOptions(){
			var self = this;
			self.loading = true;
			
			self.axios.post(self.productOptionUpdateUrl, {
				accesskey: self.$session.get('access_key'),
				enable_option: self.enable_option,
				data: self.productoptions,
				product_id: self.$route.params.product_id
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
                    self.loading = false;
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
        modalStepSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.productstepInsertUrl;
			}else{
				submitUrl = self.productstepUpdateUrl;
            }
			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('step-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
                    
                    self.productstepitems = response.data.result;
                    self.loading = false;
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		modalArtworkSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
            }

            let formData = new FormData();
            formData.append('imagefile', this.artwork_image);
            formData.append('artfile', this.artwork_art_file);
            formData.append('data', JSON.stringify(this.selectedItem));
            formData.append('accesskey', this.$session.get('access_key'));
            
			self.axios.post(submitUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('artwork-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		modalEmbellishmentSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.embellishmentinsertUrl;
			}else{
				submitUrl = self.embellishmentupdateUrl;
            }

            let formData = new FormData();
            formData.append('imagefile', this.artwork_image);
            formData.append('artfile', this.artwork_art_file);
            formData.append('data', JSON.stringify(this.selectedItem));
            formData.append('accesskey', this.$session.get('access_key'));
            
			self.axios.post(submitUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('embellishment-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		modalTierPriceSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.productTierPriceInsertUrl;
			}else{
				submitUrl = self.productTierPriceUpdateUrl;
            }
			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('tierprice-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
                    
                    self.producttierpriceitems = response.data.result;
                    self.loading = false;
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		modalProductFieldSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedFieldItem.id == 0){
				submitUrl = self.productFieldInsertUrl;
			}else{
				submitUrl = self.productFieldUpdateUrl;
            }
			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedFieldItem,
				product_id: this.$route.params.product_id
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('productfield-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
                    
                    self.productfielditems = response.data.result;
                    self.loading = false;
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		
        arrangeSteps(){
            this.productstepitems

        },
		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
                accesskey: self.$session.get('access_key'),
                product_id: self.$route.params.product_id
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    self.records = response.data.result.artworks;
					self.productstepitems = response.data.result.steps;
					
					self.producttierpriceitems = response.data.result.tierprice;
					self.productdata = response.data.result.product;
					self.datasource = response.data.result.datasource;
					self.productfielditems = response.data.result.fields;
					self.productartworkcoloritems = response.data.result.artworkcolors;
					self.embellishmentrecords = response.data.result.embellishments;
					if(response.data.result.logo_positions != null){
						self.positions = response.data.result.logo_positions;
					}else{
						self.positions = [];
					}
					
					//self.productartworkcoloritems[1].selected = true;

					self.enable_option = response.data.result.product.enable_option;
					if(response.data.result.product.options != null){
						self.productoptions = JSON.parse(response.data.result.product.options);
					}else{
						self.productoptions = {index:0, children:[]};
					}
					

					self.loading = false;
					self.totalRows = self.records.length;

					self.productstepitems.forEach(function(field){
                        if(field.parent != 0){
                            field.text = field.title;
                        }else{
                            field.html = '----- '+field.title+' -----';
                            //field.disabled = true;
                        }
                        field.value = field.id;
					});

					self.productcolorselected = JSON.parse(self.productdata.color_data);
					
                    
                    self.breadcrumb[2].text = self.productdata.title;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		addStyleModal(){
			var t = new Date();
			this.productoptions.children.push({id:t.getTime(), title:'', meshes:[], position:0});
		},
		addMeshModal(parent){
			var t = new Date();
			parent.push({id:t.getTime(), title:'', children:[], mesh:'', position:0});
		},
		addOptionModal(parent){
			var t = new Date();
			parent.push({id:t.getTime(), title:'', code:'', position:0});
		},
		deleteItem(items, index){
			items.splice(index,1);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		showCsvModal(){
			var self = this;
			self.loading = true;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to generate product csv!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.csvgenUrl, {
						accesskey: self.$session.get('access_key'),
						product_id: self.productdata.product_id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.loading = false;
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
						}
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		loadMasterSVG(){
            var self = this;
            var http = new XMLHttpRequest();
            http.open( 'GET', this.$root.MEDIAPATH+this.$session.get('user_info').uniq_id+'/products/master.svg', true );
            http.onload = function() {
                let parser = new DOMParser()
                let svgdom = parser.parseFromString(this.response, "image/svg+xml");
				self.svgdata = svgdom;

				self.svgdisplay = this.response;
				
				/*
				var serializedSVG = new XMLSerializer().serializeToString(this.svgdata);
				var xmldata = 'data:image/svg+xml;base64,'+btoa(serializedSVG);
				document.getElementById("svgimage").src = xmldata;
				*/

				var svg = self.svgdata.getElementById('logos');
				var childnodes = svg.childNodes;
				var positions = [];
				for(var _index=0; _index < childnodes.length; _index++){
					var tag = svg.childNodes[_index];
					if(tag.tagName != undefined || tag.tagName == 'linearGradient'){
						positions.push(tag.id);
						self.productdata.logo_positions.push({id:self.posindex++, title:tag.getAttribute('label'), area:[tag.getAttribute('x'), tag.getAttribute('y'), tag.getAttribute('width'), tag.getAttribute('height')], action:''});
						console.log(tag.getAttribute('x')+" "+tag.getAttribute('y')+" "+tag.getAttribute('width')+" "+tag.getAttribute('height'));
					}
				}
            };
            http.send();
        },
	}
}
</script>